var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.33333C4.52667 3.33333 3.33333 4.52667 3.33333 6C3.33333 7.47333 4.52667 8.66667 6 8.66667C7.47333 8.66667 8.66667 7.47333 8.66667 6C8.66667 4.52667 7.47333 3.33333 6 3.33333ZM1.33333 8H0V10.6667C0 11.4 0.6 12 1.33333 12H4V10.6667H1.33333V8ZM1.33333 1.33333H4V0H1.33333C0.6 0 0 0.6 0 1.33333V4H1.33333V1.33333ZM10.6667 0H8V1.33333H10.6667V4H12V1.33333C12 0.6 11.4 0 10.6667 0ZM10.6667 10.6667H8V12H10.6667C11.4 12 12 11.4 12 10.6667V8H10.6667V10.6667Z",
    fill: "#D74837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterFocus);
export default __webpack_public_path__ + "97131/static/media/center-focus.dbefcfb78d5670a070e9926b7814be2a.svg";
export { ForwardRef as ReactComponent };